/* @flow */

export default (times: number, tabStop: number): string => {
  if (times === 0) {
    return '';
  }

  return new Array(times * tabStop).fill(' ').join('');
};
